import React from 'react';

import './plan-title-container.css';

export const PlanTitleContainer = ({ children }) => (
  <div className="plan-title-container">{children}</div>
);
